"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Gottimation = exports.DEFAULT_SKIN_ID = void 0;
const Skeleton_1 = require("./core/Skeleton");
const formatters_1 = require("./formatters");
const AnimationTrack_1 = require("./core/AnimationTrack");
const LazyDynamicAtlasLoader_1 = require("./core/Loaders/LazyDynamicAtlasLoader");
const Loader_1 = require("../lib/Loader");
const utils_1 = require("../utils");
const Bone_1 = require("./core/Bone");
exports.DEFAULT_SKIN_ID = 'default.png';
const resolveRenderer = (opts) => {
    if (typeof PIXI !== 'undefined') {
        let canvas;
        let rendererOpts;
        if (!opts || !opts.rendererOpts) {
            if (opts && opts.canvas) {
                canvas = opts.canvas;
            }
            else {
                if (typeof document === 'undefined') {
                    throw new Error(`No document object found on global scope.`);
                }
                let canvas;
                if (opts === null || opts === void 0 ? void 0 : opts.canvasId) {
                    if (typeof document !== 'undefined') {
                        canvas = document.getElementById(opts.canvasId);
                    }
                    if (!canvas) {
                        throw new Error(`Could not find a canvas reference for id: ${opts.canvasId}`);
                    }
                }
                else {
                    canvas = document.createElement('canvas');
                    document.body.appendChild(canvas);
                }
                if (!canvas) {
                    throw new Error(`Was not able to create a canvas and no canvas was passed in as an init prop.`);
                }
            }
            rendererOpts = { view: canvas };
        }
        else {
            rendererOpts = opts.rendererOpts;
        }
        if (typeof PIXI['autoDetectRenderer'] !== 'undefined') {
            return PIXI.autoDetectRenderer(rendererOpts);
        }
        else if (typeof PIXI.WebGLRenderer !== 'undefined') {
            try {
                return new PIXI.WebGLRenderer(rendererOpts);
            }
            catch (err) {
                return new PIXI.CanvasRenderer(rendererOpts);
            }
        }
        else if (typeof PIXI.CanvasRenderer !== 'undefined') {
            return new PIXI.CanvasRenderer(rendererOpts);
        }
        else {
            throw new Error(`Could not find a Renderer constructor on PIXI global object`);
        }
    }
    else {
        throw new Error(`No global PIXI object found.`);
    }
};
class Gottimation {
    constructor(data, projectPath, loader, initOptions, preloadedSkins) {
        this.allSkeletons = [];
        initOptions = initOptions ? initOptions : { lazyLoadTextures: true };
        this.skeletonData = formatters_1.formatSkeletonData(data);
        const renderer = initOptions.renderer || resolveRenderer(initOptions);
        this.renderer = renderer;
        this.atlasLoader = new LazyDynamicAtlasLoader_1.LazyDynamicAtlasLoader(data.atlases, loader, projectPath, renderer, preloadedSkins);
        Skeleton_1.Skeleton.create = this.createSkeleton.bind(this);
        Skeleton_1.Skeleton.createWithAsyncOptions = this.createSkeletonWithAsyncOptions.bind(this);
        /*
        this.updateEmitter.on('create-atlas', (atlasData: AtlasData) => {
        });
        this.updateEmitter.on('update-atlas', (atlasData: AtlasData) => {
        });
        this.updateEmitter.on('delete-atlas', (atlasData: AtlasData) => {
        });
        this.updateEmitter.on('update-skin', () => {
        });
        this.updateEmitter.on('delete-skin', () => {
        })

         */
    }
    init(metaData) {
        return __awaiter(this, void 0, void 0, function* () {
        });
    }
    handleUpdate(a, entity, payload) {
        switch (entity) {
            case "animation":
                switch (a) {
                    case 'create':
                    case 'update':
                    case 'delete':
                }
            case "attachment":
                switch (a) {
                    case 'create':
                    case 'update':
                    case 'delete':
                }
            case "skeleton":
                switch (a) {
                    case 'create':
                    case 'update':
                    case 'delete':
                }
            case "skin":
                switch (a) {
                    case 'create':
                    case 'update':
                    case 'delete':
                }
            case "sub-attachment":
                switch (a) {
                    case 'create':
                    case 'update':
                    case 'delete':
                }
        }
    }
    static clearColliderManager(manager) {
        delete Skeleton_1.Skeleton.prototype.colliderManager;
        delete Bone_1.Bone.prototype.colliderManager;
        delete AnimationTrack_1.AnimationTrack.prototype.colliderManager;
    }
    static useColliderManager(manager) {
        if (AnimationTrack_1.AnimationTrack.prototype.colliderManager) {
            if (AnimationTrack_1.AnimationTrack.prototype.colliderManager !== manager) {
                console.warn(`Changing the collider manager after already setting it can cause undocumented behavior and issues/bugs.`);
            }
            else {
                console.warn('Redundantly using the same collider manager');
            }
        }
        Skeleton_1.Skeleton.prototype.colliderManager = manager;
        Bone_1.Bone.prototype.colliderManager = manager;
        AnimationTrack_1.AnimationTrack.prototype.colliderManager = manager;
    }
    getSlotTags(slotId) {
        return this.atlasLoader.slotIdToTagLookup[slotId];
    }
    getSkinSlotTexturesByTag(tag, skin) {
        return __awaiter(this, void 0, void 0, function* () {
            if (skin.skinTexture) {
                const slots = this.atlasLoader.getSlotsForTexture(skin.skinTexture, skin.atlasName, tag);
                return Object.keys(slots).map(key => {
                    return { slotId: parseInt(key), texture: slots[key] };
                    // @ts-ignore
                }).flat();
            }
            else {
                if (!(skin.atlasName in this.atlasLoader.atlasNameToSkinNameToSlotTextures)) {
                    throw new Error(`Invalid atlas name ${skin.atlasName}`);
                }
                const array = [];
                const slots = skin.skinUrl ?
                    yield this.atlasLoader.loadSkinSlotsByUrl(skin.atlasName, skin.skinUrl) :
                    yield this.atlasLoader.loadSkinSlots(skin.atlasName, skin.skinName);
                for (let slotId in slots) {
                    const parsedSlotId = parseInt(slotId);
                    if (this.atlasLoader.slotHasTag(parsedSlotId, tag)) {
                        array.push({ slotId: parsedSlotId, texture: slots[slotId] });
                    }
                }
                return array;
            }
        });
    }
    static Init(projectPath, initOptions, loader) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!loader) {
                loader = new Loader_1.Loader(projectPath);
                yield loader.initialize();
            }
            if (initOptions === null || initOptions === void 0 ? void 0 : initOptions.colliderManager) {
                Gottimation.useColliderManager(initOptions === null || initOptions === void 0 ? void 0 : initOptions.colliderManager);
            }
            if (!initOptions || !initOptions.renderer) {
                console.warn('No pixi renderer was passed in to init options, this will cause problems unless you use the renderer made in the gottimation constructor for the rest of your game rendering. (Accessed through gottimation.renderer)');
            }
            let lastTimestamp = 0;
            const timestampPath = `${projectPath}/last_edit_timestamp`;
            const globalProjectDataPath = `${projectPath}/project.json`;
            const metaDataPath = `${projectPath}/meta.json`;
            const preloadedSkins = [];
            const getAtlasDefaults = (requester, atlasArray, isHttpRequest) => __awaiter(this, void 0, void 0, function* () {
                for (let i = 0; i < atlasArray.length; i++) {
                    const a = atlasArray[i];
                    const url = `${projectPath}/atlases/${a.name}/${exports.DEFAULT_SKIN_ID}`;
                    const imageData = yield requester(url, !isHttpRequest);
                    if (!imageData) {
                        console.warn(`Failed to load default atlas image for atlas: ${a.name}`);
                        continue;
                    }
                    if (isHttpRequest && loader) {
                        yield loader.saveImageData(url, imageData);
                    }
                    const finalTexture = yield utils_1.getTextureFromBlob(imageData);
                    preloadedSkins.push({ atlasName: a.name, skinId: exports.DEFAULT_SKIN_ID, texture: finalTexture });
                }
                ;
            });
            const requestAndSaveGlobalData = () => __awaiter(this, void 0, void 0, function* () {
                const _globalData = yield utils_1.httpGetAsync(globalProjectDataPath);
                if (!_globalData) {
                    throw new Error(`Could not find global project data at path ${_globalData}`);
                }
                if (loader) {
                    yield loader.saveJson(timestampPath, Date.now());
                    yield loader.saveJson(globalProjectDataPath, _globalData);
                }
                if (initOptions === null || initOptions === void 0 ? void 0 : initOptions.preloadAtlasDefaults) {
                    yield getAtlasDefaults(utils_1.httpGetAsync, _globalData.atlases, true);
                }
                return _globalData;
            });
            let needsHttpRequest = true;
            try {
                lastTimestamp = yield loader.loadJson(timestampPath, true);
            }
            catch (err) { }
            if (!lastTimestamp) {
                const globalData = yield requestAndSaveGlobalData();
                return new Gottimation(globalData, projectPath, loader, initOptions, preloadedSkins);
            }
            else {
                const metaData = (initOptions === null || initOptions === void 0 ? void 0 : initOptions.metaData) || (yield utils_1.httpGetAsync(metaDataPath));
                if (metaData && metaData.ts < lastTimestamp) {
                    needsHttpRequest = false;
                }
                if (!metaData) {
                    console.warn(`Did not find any meta.json file at ${metaDataPath} Could not adhoc updates, requesting global data.`);
                }
            }
            /*
            const metaData : ProjectMetaData = initOptions?.metaData || await httpGetAsync(metaDataPath);
            const neededSkeletonUpdates = [];
            const neededAtlasUpdates = [];
    
            for(let i = 0; i < metaData.skeletonEdits.length; i++) {
                const skelId = metaData.skeletonEdits[i];
                const ts = metaData.skeletonEdits[i+1];
                if(ts > lastTimestamp) {
                    neededSkeletonUpdates.push(skelId);
                }
            }
            for(let i = 0; i < metaData.atlasEdits.length; i++) {
                const atlasId = metaData.atlasEdits[i];
                const ts = metaData.atlasEdits[i+1];
                if(ts > lastTimestamp) {
                    neededAtlasUpdates.push(atlasId);
                }
            }
    
             */
            let globalData;
            if (needsHttpRequest) {
                globalData = yield requestAndSaveGlobalData();
                return new Gottimation(globalData, projectPath, loader, initOptions, preloadedSkins);
            }
            else {
                globalData = yield (loader === null || loader === void 0 ? void 0 : loader.loadJson(globalProjectDataPath));
                if (!globalData) {
                    console.warn(`Initialization expected local global data to be found but it was not, making http request.`);
                }
                else {
                    if (initOptions.preloadAtlasDefaults) {
                        yield getAtlasDefaults(loader.loadImageData.bind(loader), globalData.atlases, false);
                    }
                }
            }
            if (!globalData) {
                globalData = yield requestAndSaveGlobalData();
                return new Gottimation(globalData, projectPath, loader, initOptions);
            }
            //todo: this will be nice eventually to have the option of a web server or file server which can tell us which new files we'll need to get.
            if (initOptions === null || initOptions === void 0 ? void 0 : initOptions.adhocUpdateGetter) {
                try {
                    const updates = initOptions.adhocUpdateGetter(lastTimestamp);
                }
                catch (err) {
                    //console.error(err);
                }
            }
            return new Gottimation(globalData, projectPath, loader, initOptions, preloadedSkins);
        });
    }
    _createSkeleton(name, opts) {
        const skeletonData = this.skeletonData[name];
        if (!skeletonData)
            throw new Error(`Invalid skeleton name: ${name}. Not found in the lookup.`);
        const skeleton = new Skeleton_1.Skeleton(skeletonData, this.atlasLoader, opts === null || opts === void 0 ? void 0 : opts.activeSlotTextures, opts === null || opts === void 0 ? void 0 : opts.direction);
        if (opts === null || opts === void 0 ? void 0 : opts.action) {
            skeleton.play(opts.action, null, opts.playOptions);
        }
        return skeleton;
    }
    createSkeleton(name, opts) {
        const skeleton = this._createSkeleton(name, opts);
        return skeleton;
    }
    createSkeletonWithAsyncOptions(name, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const skeleton = this._createSkeleton(name, opts);
            const tracks = opts.attachmentSlots ? opts.attachmentSlots.map(s => {
                return skeleton.mountAttachment(s.attachmentSlotName, s.attachmentName, s.action, s.playOptions);
            }) : [];
            if (opts.skins) {
                const notloaded = [];
                for (let i = 0; i < opts.skins.length; i++) {
                    if (this.atlasLoader.loadedSkins[opts.skins[i].skinName]) {
                        notloaded.push(opts.skins[i]);
                    }
                }
                yield skeleton.setSkins(opts.skins);
            }
            return { skeleton, tracks };
        });
    }
    preloadSkins(skins) {
        return __awaiter(this, void 0, void 0, function* () {
            const { valid } = utils_1.validateSkinParams(skins);
            return null;
        });
    }
}
exports.Gottimation = Gottimation;
//# sourceMappingURL=module.js.map